import type { JSX, ComponentChildren } from "preact";
import { Link } from "wouter-preact";
import { classNames } from "@gss/common/classNames";

interface Props {
    className?: string;
    href?: string;
    absolute?: boolean;
    active?: boolean;
    disabled?: boolean;
    isTab?: boolean;
    tabIndex?: number;
    "data-nav-tabs-index"?: number;
    children?: ComponentChildren;
    onClick?: () => void;
}

export function NavLink({
    className,
    href,
    absolute,
    active,
    disabled,
    isTab,
    "data-nav-tabs-index": dataNavTabsIndex,
    tabIndex,
    children,
    onClick,
}: Props): JSX.Element {
    const fullClassName = classNames(
        "nav-link",
        active && "active",
        disabled && "disabled",
        className,
    );

    if (href != null && !absolute) {
        return (
            <Link
                href={href}
                className={fullClassName}
                tabIndex={tabIndex}
                data-nav-tabs-index={dataNavTabsIndex}
                aria-disabled={disabled}
                role={isTab ? "tab" : undefined}
                aria-selected={isTab ? active : undefined}
                aria-current={!isTab && active ? "page" : undefined}
            >
                {children}
            </Link>
        );
    }

    return (
        <a
            href={href}
            onClick={onClick}
            className={fullClassName}
            tabIndex={tabIndex}
            data-nav-tabs-index={dataNavTabsIndex}
            aria-disabled={disabled}
            role={isTab ? "tab" : undefined}
            aria-selected={isTab ? active : undefined}
            aria-current={!isTab && active ? "page" : undefined}
        >
            {children}
        </a>
    );
}
